import { AbstractControl, ValidationErrors } from '@angular/forms';
import { PASSWORD_RULES } from '../constants/signup.constants';

export interface PasswordRuleState {
  id: string;
  label: string;
  met: boolean;
}

/**
 * Evalua una contraseña contra PASSWORD_RULES.
 * Lo usa el checklist para pintar cada regla en gris o en verde.
 */
export function evaluatePasswordRules(value: string): PasswordRuleState[] {
  const password = value || '';
  return PASSWORD_RULES.map((rule) => ({
    id: rule.id,
    label: rule.label,
    met: rule.test(password),
  }));
}

/**
 * Una contraseña es valida solo si cumple todas las reglas.
 */
export function isPasswordValid(value: string): boolean {
  const password = value || '';
  return PASSWORD_RULES.every((rule) => rule.test(password));
}

/**
 * Validador del formulario construido desde las mismas reglas del checklist,
 * para que nunca puedan quedar desalineados (un check verde con el boton
 * deshabilitado, o al reves).
 * Deja en el error los ids de las reglas que faltan.
 */
export function passwordRulesValidator(
  control: AbstractControl
): ValidationErrors | null {
  const password = control.value || '';

  // El campo vacio lo reporta Validators.required, no este validador
  if (!password) return null;

  const unmet = PASSWORD_RULES.filter((rule) => !rule.test(password)).map(
    (rule) => rule.id
  );

  return unmet.length ? { passwordRules: unmet } : null;
}
